module.exports = __webpack_public_path__ + "static/media/checkmark-circle-outline.f8a746c2.svg";